import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { GraphQLCommitmentParticipant } from '@sola/schema/dotcom/supporters/schema.generated.ts';
export type UsePrimaryCtaBirthdayArgs = {
  participants: GraphQLCommitmentParticipant[];
  confirmed: boolean;
};
export const usePrimaryCtaBirthday = t0 => {
  const $ = _c(17);
  const {
    participants,
    confirmed
  } = t0;
  const {
    t
  } = useTranslation("my");
  const count = participants.length;
  const gender = participants[0]?.gender ?? undefined;
  let t1;
  if ($[0] !== confirmed || $[1] !== count || $[2] !== participants[0]?.name || $[3] !== participants[1]?.name || $[4] !== t) {
    t1 = confirmed ? t("my:primaryCtaBirthday.confirmation.title", {
      name: participants[0]?.name ?? "",
      count
    }) : t("my:primaryCtaBirthday.default.title", {
      name: participants[0]?.name ?? "",
      name2: participants[1]?.name ?? "",
      count,
      context: count === 2 ? "two" : undefined
    });
    $[0] = confirmed;
    $[1] = count;
    $[2] = participants[0]?.name;
    $[3] = participants[1]?.name;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const title = t1;
  let t2;
  if ($[6] !== confirmed || $[7] !== count || $[8] !== gender || $[9] !== t) {
    t2 = confirmed ? t("my:primaryCtaBirthday.confirmation.subtitle", {
      count,
      context: gender
    }) : t("my:primaryCtaBirthday.default.subtitle", {
      count,
      context: gender
    });
    $[6] = confirmed;
    $[7] = count;
    $[8] = gender;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const subtitle = t2;
  let t3;
  if ($[11] !== count || $[12] !== gender || $[13] !== subtitle || $[14] !== t || $[15] !== title) {
    t3 = {
      t,
      count,
      gender,
      title,
      subtitle
    };
    $[11] = count;
    $[12] = gender;
    $[13] = subtitle;
    $[14] = t;
    $[15] = title;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};